import request from "./request";

/**获取用户信息
 * @param {Number} uid
 * @param {String} usertoken
 * 
*/
export async function getUserInfo(uid = 0, usertoken = "") {
  return await request.get("/wxindex/user/getinfo.html", {
    params: {
      uid,
      usertoken
    }
  });
}

/**获取轮播图数据
 * 
*/
export async function getHomeBanner() {
  return await request.get("/wxindex/news/list.html?cate_id=1");
}